export default __webpack_public_path__ + "static/media/Sammir D Dattani.281ed7d5.png";